const ENGINE_META = {
  chatgpt: { label: "ChatGPT", color: "#10A37F", accent: "bg-emerald-500" },
  claude: { label: "Claude", color: "#C97A6A", accent: "bg-orange-500" },
  gemini: { label: "Gemini", color: "#4285F4", accent: "bg-blue-500" },
  perplexity: { label: "Perplexity", color: "#1FB6FF", accent: "bg-sky-500" },
};

export default function EngineScoreCards({ scoreByEngine }) {
  const engines = Object.keys(ENGINE_META);
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3" data-testid="geo-engine-scores">
      {engines.map((e) => {
        const s = (scoreByEngine || {})[e] || {};
        const meta = ENGINE_META[e];
        const cur = s.current;
        const delta = s.delta;
        return (
          <div
            key={e}
            className="rounded-md border border-slate-200 bg-white p-4"
            data-testid={`geo-engine-card-${e}`}
          >
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <span
                  className={`h-2 w-2 rounded-full ${meta.accent}`}
                  aria-hidden
                />
                <span className="text-sm font-medium text-slate-700">
                  {meta.label}
                </span>
              </div>
              {delta != null && (
                <span
                  className={`text-[11px] font-medium px-1.5 py-0.5 rounded ${
                    delta > 0
                      ? "bg-emerald-50 text-emerald-700"
                      : delta < 0
                      ? "bg-rose-50 text-rose-700"
                      : "bg-slate-50 text-slate-600"
                  }`}
                >
                  {delta > 0 ? "+" : ""}
                  {delta}
                </span>
              )}
            </div>
            <div className="mt-2 flex items-baseline gap-1.5">
              <span className="font-display text-3xl font-semibold text-slate-900">
                {cur != null ? cur : "—"}
              </span>
              {cur != null && (
                <span className="text-sm text-slate-500">/ 100</span>
              )}
            </div>
            <div className="mt-1 text-[11px] text-slate-500">
              {s.avg_position != null
                ? `Posición media: ${s.avg_position}`
                : "Sin posición media"}
            </div>
          </div>
        );
      })}
    </div>
  );
}
